export const COLORS = ['#397DFF', '#FCB500', '#6C47FF', '#00CED4']
